module.exports = __webpack_public_path__ + "img/static.a9d46142.gif";